// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
//Last ADD : NEW'
// MODFIED DATA : 18-08-2025
import AutoLoanCollectionActionTypes from './auto-loan-collection-report.types';

/*************** Get Auto Loan Collection Details Start ******************/
export const getAutoLoanCollectionDetailsStart = (addData: any) => ({
	type: AutoLoanCollectionActionTypes.GET_AUTO_LOAN_REPORT_DETAILS_START,
	payload: addData,
});

export const getAutoLoanCollectionDetailsSuccess = (successData: any) => ({
	type: AutoLoanCollectionActionTypes.GET_AUTO_LOAN_REPORT_DETAILS_SUCCESS,
	payload: successData,
});

export const getAutoLoanCollectionDetailsFailure = (failureData: any) => ({
	type: AutoLoanCollectionActionTypes.GET_AUTO_LOAN_REPORT_DETAILS_FAILURE,
	payload: failureData,
});

export const getAutoLoanCollectionDetailsResponseReset = () => ({
	type: AutoLoanCollectionActionTypes.GET_AUTO_LOAN_REPORT_DETAILS_RESPONSE_RESET,
});

export const getAutoLoanCollectionDetailsResponseChanged = () => ({
	type: AutoLoanCollectionActionTypes.GET_AUTO_LOAN_REPORT_DETAILS_RESPONSE_CHANGED,
});
/*************** Get Auto Loan Collection Details End ******************/
